import type { RawBlock as RawBlockT } from './screen-model.ts';
import { S } from './strings.ts';

/** בלוק לא מוכר/פגום: מוצג כ-JSON מקופל, לא נזרק (11 §1). */
export function RawBlock({ block }: { block: RawBlockT }) {
  return (
    <section className="ab-block ab-raw" data-block-type="raw" data-original-type={block.originalType} data-block-id={block.id}>
      <details>
        <summary>{S.unknownBlock(block.originalType)}</summary>
        <pre dir="ltr">{JSON.stringify(block.original, null, 2)}</pre>
      </details>
    </section>
  );
}
